import TourneeFormWrapper from "../../components/tournee/TourneeFormWrapper";

const TourneeCreate = () => {
  return <TourneeFormWrapper action="create" />;
};

export default TourneeCreate;
